import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import "fontsource-roboto";
import { getBase64FileFormat } from "../utils";
import Version from "../labels/Version";
import "./header.scss";

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight: "10px",
  },
  gridUsuario: {
    marginRight: "50px",
  },
  sigLogo: {
    height: "61px",
    width: "92px",
  },
}));

const UserInformation = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const username = sessionStorage.getItem("username");
  const userProfile = sessionStorage.getItem("userProfile");
  const userImage = sessionStorage.getItem("userImage");

  const imageConsistency = (image) => {
    if (image === "") {
      return "";
    }

    let fileFormat = getBase64FileFormat(image);

    if (fileFormat === "png") {
      return `data:image/png;base64,${image}`;
    }

    if (fileFormat === "jpg") {
      return `data:image/jpg;base64,${image}`;
    }

    return "";
  };

  return (
    <div>
      <Grid container alignItems="center" direction="row">
        <Grid item>
        </Grid>
        <Grid item>
          {imageConsistency(userImage) === "" ? (
            <Avatar className={classes.large} />
          ) : (
            <img
              className={classes.large}
              src={imageConsistency(userImage)}
              style={{ borderRadius: "50%" }}
              alt={t("userImage")}
            />
          )}
        </Grid>
        <Grid className={classes.gridUsuario}>
          <Typography className={"userName"}>{username}</Typography>
          <Typography className={"userRole"}>
            {sessionStorage.getItem("roleDescription")}
          </Typography>
          <div className="version">
            <Version />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default UserInformation;
